import Phaser from "phaser";
import { FishBase } from "./FishBase";

export class TroutAI extends FishBase {
    private phase = Phaser.Math.FloatBetween(0, Math.PI * 2);

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, {
            species: "Trout",
            textureKey: "trout",
            pointValue: 25,
            swimSpeed: 110,
        });
    }

    override update(): void {
        this.phase += 0.04;
        const vx = Math.cos(this.phase) * this.swimSpeed;
        const vy = Math.sin(this.phase * 2) * this.swimSpeed * 0.6;
        this.swimWithBias(vx, vy);
    }
}
